<template>
<div>
    <!-- Modal Reidentificação do Usuário  -->
    <div class="modal fade reident_user" id="loginPausadoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
        <div class="modal-dialog modal-dialog-total modal-dialog-scrollable" role="document">
            <div class="modal-content modal-content-total">
                <div class="modal-body">
                    <template v-if="false">
                        <login :interno="true" :block_fundo="true" :lista="lista" />

                        <pre>Lista: {{ lista }}</pre>

                        <div class="mb-3">
                            <button type="button" class="btn btn-primary mr-1 mb-1" v-for="(item, iix) in lista" :key="iix" @click="ident.login = item; $refs.campo_senha.focus();">
                                {{ item }}
                            </button>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <input
                                    ref="campo_login"
                                    placeholder="Login..."
                                    type="text"
                                    v-model="ident.login"
                                    required
                                    :validate="validate"
                                    autocomplete="off"
                                    class="form form-control"
                                    @keydown.enter="atualizar" />
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col col-12">
                                <input
                                    ref="campo_senha"
                                    placeholder="Senha..."
                                    type="text"
                                    id="password"
                                    style="-webkit-text-security: disc;"
                                    required
                                    :validate="validate"
                                    v-model="ident.senha"
                                    autocomplete="off"
                                    class="form form-control"
                                    @keydown.enter="atualizar" />
                            </div>
                        </div>

                        <pre>{{ $store.state.user }}</pre>
                    </template>
                </div>
                <div class="modal-footer" v-if="false">
                    <button type="button" class="btn btn-secondary" @click="fechar_modal()">Fechar</button>
                    <az-submit @click="atualizar()">Confirmar</az-submit>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzSubmit from '../util/AzSubmit.vue';
import Login from '../../components/Login.vue';

export default {
    data() { 
        return { 
            validate: false, 
            ident: { 
                login: "",
                senha: "", 
            }, 
            callback: null,
            final: null, 
            lista: [], 
        };
    },

    props: ['tipo'],

    components: { 
        AzSubmit, 
        Login, 
    }, 

    computed: { 
        modal_name: function () { 
            return 'loginPausadoModal'; 
        }
    },

    methods: { 
        pausar() { 
            this.lista.push(this.$store.state.user.st_login);
            this.lista = _.uniq(this.lista).sort();

            this.$store.commit("setUser", null);
        },

        atualizar () { 
            if ( !this.ident.login ) { 
                this.$toast.add({
                    severity: "error",
                    summary: "Identificação",
                    detail: "Login não informado.",
                    life: 3000
                });
                return;
            }

            if ( !this.ident.senha ) { 
                this.$toast.add({
                    severity: "error",
                    summary: "Identificação",
                    detail: "Senha não informada.",
                    life: 3000
                });
                return;
            }

            this.callback(this.ident, () => { 
                this.fechar_modal();        
            });
        }, 

        abrir (callback = null, final = null) { 
            this.lista.push(this.$store.state.user.st_login);
            this.lista = _.uniq(this.lista).sort();

            console.log('lista', this.lista);

            /*
            this.lista = this.$store.state.contexto['ident_logins']
                ? this.$store.state.contexto['ident_logins']
                : [];
            */

            this.callback = callback;
            this.final = final; 

            this.validate = false; 

            this.ident.login = "";
            this.ident.senha = "";

            this.axios.defaults.headers.post["Authorization"] = "";
            this.axios.defaults.headers.get["Authorization"] = "";

            $('#' + this.modal_name).modal('show');
        },

        fechar_modal () { 
            $('#' + this.modal_name).modal('hide');
        }
    }
}
</script>

<style scoped>
.modal-dialog-total {
  top: 0;
  width: 100% !important;
  height: 100% !important;
  padding: 0 !important;
  max-width: 100% !important;
  max-height: 100% !important;
  margin-top: 0px;
  margin-bottom: 0px;
  margin: 0px !important;
}

.modal-content-total {
  height: 100% !important;
  max-height: 100% !important;
}
</style>